export const EMIRATES = [
  "Abu Dhabi",
  "Dubai",
  "Sharjah",
  "Ajman",
  "Umm Al Quwain",
  "Ras Al Khaimah",
  "Fujairah",
];

export const ARRANGEMENT_TYPES = ["Full-time", "Part-time", "Occasional / Temporary"];

export const LIVING_OPTIONS = ["Live-in", "Live-out"];

export const CHILD_AGE_RANGES = [
  "Newborn (0–12 months)",
  "Toddler (1–3 years)",
  "Preschool (3–5 years)",
  "School age (5–12 years)",
  "Teen (12+ years)",
];

export const CHILDREN_COUNT = ["1", "2", "3", "4+"];

export const PREFERRED_CONTACT = ["Email", "Phone call", "WhatsApp message"];

export const YEARS_EXPERIENCE = [
  "Less than 1 year",
  "1–2 years",
  "3–5 years",
  "6–9 years",
  "10+ years",
];

export const NANNY_CARE_TYPES = [
  "Newborn care",
  "Toddler care",
  "School-age care",
  "Special needs experience",
  "Household support related to children",
];

export const LANGUAGES = [
  "English",
  "Arabic",
  "Hindi",
  "Urdu",
  "Tagalog",
  "French",
  "Other",
];
